import { defineStore } from 'pinia' //引入

const useStore = defineStore('storeId', {
  // arrow function recommended for full type inference
  state: () => {
    return {
      // 个人头像Url
      myIamgeUrl: "",
      searchShowDiv: true, // 搜索框的状态
      searchShow: true,
      // 搜索框的值
      queryPageData: {},
      token: '',
      userId: '',
      counter: 0,
      name: 'Eduardo',
      isAdmin: true,
      // countryCode: 'china',  //test测试环境
      countryCode: 'China', // prod生产环境
      tabbarValue: 0, // tabbar

      addColor: null,
      colorData: null,
      colorDataArrs: [],
      // 工序值
      process: {},
      // 订单编号
      recipeNo: '',
      // 单工序

      // 配方详情查询类型 1:我的;2其他
      recipeQueryType: '',
      // 配方详情数据
      recipeDetails: {},
      // 使用配方数据
      recipeDetailsUse: {},
      // 订单详情的procedures
      proceduresArrG: [],
      // 添加新色
      addColorData: {},
      // 新色完成的数据
      addColorD: [],

      // 多工序

      // 工序一
      // 配方详情数据
      recipeDetails1: {},
      // 使用配方数据
      recipeDetailsUse1: {},
      // 订单详情的procedures
      proceduresArrG1: [],
      industryData1: [],
      // 添加新色
      addColorData1: {},
      // 新色完成的数据
      addColorD1: [],

      // 工序二
      // 配方详情数据
      recipeDetails2: {},
      // 使用配方数据
      recipeDetailsUse2: {},
      // 订单详情的procedures
      proceduresArrG2: [],
      // 添加新色
      addColorData2: {},
      // 新色完成的数据
      addColorD2: [],

      // 工序三
      // 配方详情数据
      recipeDetails3: {},
      // 使用配方数据
      recipeDetailsUse3: {},
      // 订单详情的procedures
      proceduresArrG3: [],
      // 添加新色
      addColorData3: {},
      // 新色完成的数据
      addColorD3: [],

      // 使用配方的参数
      recipeDataStore: [],
      recipeDataStore1: [],
      recipeDataStore2: [],
      recipeDataStore3: [],

      // 新增配方
      processArrColor: [],
      processArrColor2: [],
      processArrColor3: [],
      // 新增配方重量
      processWeightData: [],
      processWeightData2: [],
      processWeightData3: [],

      // 修改配方值，返回时记录
      recipeState: [],
      gNumG: [],

      // 搜索条件的存储(用于:返回搜索列表时赋值)
      searchVla: '', // 搜索框
      searchState: '', // 是否给搜索框赋值
      recipeAddData: '', // 搜索框条件集合
      fieldValue1: '', // 车色号

      // Gift redemption module
      itemToBeRedeemed: null,
      collectionRecipeItem: null,//征集配方
    };
  },
  // 相当于 vue 中的 computed 计算属性
  getters: {
	
	},
  persist: {
    enabled: true, // 开启存储
    // **strategies: 指定存储位置以及存储的变量都有哪些,该属性可以不写，不写的话默认是存储到sessionStorage里边，默认存储state里边的所有数据**
    strategies:[
      { storage: sessionStorage, paths: ["fieldValue1","recipeAddData","searchVla","searchShowDiv","processWeightData","processWeightData2","processWeightData3","processArrColor","processArrColor2","processArrColor3"]},
      { storLoad: localStorage, paths: ["queryPageData",'token','userId',"myIamgeUrl","recipeQueryType","recipeDataStore3","recipeDataStore2","recipeDataStore1","recipeDataStore","process","addColorD1","addColorD2","addColorD3","addColorData1","addColorData2","addColorData3","proceduresArrG1","proceduresArrG2","proceduresArrG3","recipeDetailsUse1","recipeDetailsUse2","recipeDetailsUse3","recipeDetails1","recipeDetails2","recipeDetails3","addColorD","addColorData","proceduresArrG","recipeDetailsUse","industryData","recipeDetails","recipeNo","counter",'addColor','colorData','colorDataArrs','tabbarValue','recipeState']},
      // storage 存储到哪里 sessionStorage/localStorage
      // paths是一个数组,要存储缓存的变量,当然也可以写多个
      // paths如果不写就默认存储state里边的所有数据，如果写了就存储指定的变量
    ]
  },
   // 相当于 vue 中的 methods 方法
  actions:{
    // 根据这个方法来知道，组件的切换
    searchShowTrueFun(){
      this.searchShowDiv = true;
    },
    // 根据这个方法来知道，组件的切换
    searchShowFalseFun(){
      this.searchShowDiv = false;
    },
    increment() {
      this.counter++
    },

    // Gift redemption module
    clearRedemptionState() {
      this.itemToBeRedeemed = null;
      // console.log('cleared redemption state... ', this.itemToBeRedeemed);
    },
    setRedemptionItem(item) {
      this.itemToBeRedeemed = item;
    }
  }
})
export default useStore //导出
